import styled from '@emotion/styled'
import * as React from 'react'

import { Space } from '..'
import { Switch, SwitchProps } from '../switch'

type LabelState = 'yes' | 'no' | 'unavailable'

const getColor = (state: LabelState) => {
  switch (state) {
    case 'yes':
      return 'var(--Graphite)'
    case 'no':
      return 'var(--Graphite)'
    case 'unavailable':
      return 'var(--White60)'
  }
}

export type SwitchLabelProps = {
  state: LabelState
}

export const StyledSwitchLabelWrapper = styled.div<SwitchLabelProps>`
  span.label {
    color: ${({ state }) => getColor(state)};
  }
  span.MuiSwitch-thumb {
    color: var(--Orange-Dark);
  }
`

const getTitleCaseLabel = (state: LabelState) => {
  const label = `${state[0].toUpperCase()}${state.substr(1)}`
  return label
}

const getState = (
  isDisabledShownAsUnavailable: boolean,
  isDisabled?: boolean,
  isChecked?: boolean
) => {
  switch (true) {
    case isDisabled && isDisabledShownAsUnavailable:
      return 'unavailable'
    case isDisabled:
      return isChecked ? 'yes' : 'no'
    case isChecked:
      return 'yes'
    default:
      return 'no'
  }
}

type SwitchWithLabelProps = SwitchProps & {
  isDisabledShownAsUnavailable?: boolean
  labelPosition?: 'left' | 'right'
}

export const SwitchWithLabel = ({
  isChecked,
  isDisabled,
  isDisabledShownAsUnavailable = true,
  labelPosition = 'left',
  ...props
}: SwitchWithLabelProps) => {
  const state = getState(isDisabledShownAsUnavailable, isDisabled, isChecked)

  return (
    <StyledSwitchLabelWrapper state={state}>
      <Space isflex alignItems="center">
        {labelPosition === 'left' && <span className="label">{getTitleCaseLabel(state)}</span>}
        <Switch isChecked={isChecked} isDisabled={isDisabled} {...props} />
        {labelPosition === 'right' && <span>{getTitleCaseLabel(state)}</span>}
      </Space>
    </StyledSwitchLabelWrapper>
  )
}
